// extracted by mini-css-extract-plugin
export default {"divider":"divider___AO5lr","divider_line":"divider_line___jcaja"};